import ko from "./ko.json";
import en from "./en.json";
import jp from "./jp.json";
import tw from "./tw.json";
import cn from "./cn.json";
import { LOCALES } from "../constants";

const TEXT = {
    "ko-KR": ko,
    "en-US": en,
    "ja-JP": jp,
    "zh-TW": tw,
    "zh-CN": cn,
};

const getUIText = (lang, key) => {
    const value = TEXT[lang]?.[key] ?? TEXT[LOCALES.KO][key];
    return typeof value === "string" ? value : "";
};

export { getUIText };
